<template>
    <v-container>
        <v-row>
            <v-col>
                <div v-html="content">
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        data() {
            return {
                content: '',
                loading: true,
                url: ''
            }
        },
        mounted() {
            // this.loadContent()
            if(this.$route.query.hasOwnProperty('id')) {
                    this.url = `${this.$store.state.client_vars.STATIC}?id=${this.$route.query.id}`
                } else {
                    this.url = `${this.$store.state.client_vars.STATIC}`
                }

                this.$axios.get(this.url)
                    .then(response => {
                        this.content = response.data
                        this.loading = false
                    })
                    .catch(error => console.log('Failed to update from MOH', error))
        },
        beforeRouteUpdate (to, from, next) {
            if(this.$route.query.hasOwnProperty('id')) {
                this.url = `${this.$store.state.client_vars.STATIC}?id=${to.query.id}`
            } else {
                this.url = `${this.$store.state.client_vars.STATIC}`
            }

            this.$axios.get(this.url)
                .then(response => {
                    this.content = response.data
                    this.loading = false
                })
                .catch(error => console.log('Failed to update from MOH', error))
            next()
        },
        methods: {
            loadContent: () => {

                if(this.$route.query.hasOwnProperty('id')) {
                    this.url = `${this.$store.state.client_vars.STATIC}?id=${this.$route.query.id}`
                } else {
                    this.url = `${this.$store.state.client_vars.STATIC}`
                }

                this.$axios.get(this.url)
                    .then(response => {
                        this.content = response.data
                        this.loading = false
                    })
                    .catch(error => console.log('Failed to update from MOH', error))
            }
        }
    }
</script>

<style scoped>

</style>